<template>
  <v-textarea
    id="input:txtObservacao"
    v-model="payload.txtObservacao"
    label="Observação"
    :loading="loading"
    outlined
  />
</template>

<script>
export default {
  name: 'ObservationTxtArea',
  props: {
    payload: {
      type: Object,
      default() {
        return {
          txtObservacao: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>
